module.exports = __webpack_public_path__ + "img/atx.6c31d249.jpg";